/**
 * PresenceProvider Component
 *
 * Initializes presence tracking for the current user.
 * This should be rendered once in the app, after AuthProvider.
 *
 * The provider tracks user activity to determine if they're
 * currently using the app, allowing push notifications to be
 * skipped when users will see in-app notifications.
 */

"use client";

import { usePresence } from "@/hooks/usePresence";

export function PresenceProvider({ children }: { children: React.ReactNode }) {
  // Initialize presence tracking
  usePresence();

  return <>{children}</>;
}
